import { render, staticRenderFns } from "./CoursesPreview.vue?vue&type=template&id=5ac6a3ec&"
import script from "./CoursesPreview.vue?vue&type=script&lang=js&"
export * from "./CoursesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports